import { createClient } from "tinacms/dist/client";
import { queries } from "./types.ts";
export const client = createClient({
  cacheDir: '/vercel/path0/tina/__generated__/.cache/1791854780160',
  url: 'https://content.tinajs.io/2.3/content/2186fd46-c141-47b7-b5ab-64d819e93564/github/main',
  token: 'c3800ad10046bf82f75e4423cca6a232464d560e',
  queries
});
export default client;